import { useEffect, useRef } from "react";
import useAppContextState from "./useContextState";
import { weekdaysOrAll } from "app/@utils/weekdays";

// State of the table weekday toggles. Starts with the report execution's weekdays (all days when none) and
// re-applies them whenever another execution is loaded or the execution is cleared.
export default function useWeekdayFilterState(reportWeekdays) {
    const ctx = useAppContextState({ selectedWeekdays: weekdaysOrAll(reportWeekdays) })
    const { updateState } = ctx
    const isFirstRunRef = useRef(true)

    useEffect(() => {
        if (isFirstRunRef.current) {
            isFirstRunRef.current = false
            return
        }
        updateState({ selectedWeekdays: weekdaysOrAll(reportWeekdays) })
    }, [reportWeekdays, updateState])

    return ctx
}
